import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { IGameficacaoDashboardResponse } from "./types";
import { inject, injectable } from "inversify";
import { IGameficacaoDashboardGateway } from "./IGameficacaoDashboardGateway";

@injectable()
export default class GameficacaoDashboardGateway
  implements IGameficacaoDashboardGateway
{
  @inject(DITypes.INDICADORES_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async handleObterGameficacao(): Promise<
    IGameficacaoDashboardResponse | undefined
  > {
    const response = await this.httpClient.get<IGameficacaoDashboardResponse>({
      url: "financas/MinhaGestao/v1/obter-gameficacao-para-dashboard"
    });

    if (!response.body) return undefined;

    return response.body;
  }
}
